import AppUdtablesIndex from "./udTable.vue";
import AppUdtablesList from "./list/list.vue";
import AppUdtablesItem from "./item/item.vue";

const routes = [
  {
    path: "/udtable",
    component: AppUdtablesIndex,
    meta: {
      auth: {
        roles: "udTable.index",
        redirect: { name: "auth.login" },
        forbiddenRedirect: "/403"
      }
    },
    children: [
      {
        path: "",
        name: "udTable.index",
        component: AppUdtablesList,
        meta: {
          auth: {
            roles: "udTable.index",
            redirect: { name: "auth.login" }
          }
        }
      },
      {
        path: "create",
        name: "udTable.create",
        component: AppUdtablesItem,
        meta: {
          auth: {
            roles: "udTable.create",
            redirect: { name: "udTable.index" }
          }
        }
      },
      {
        path: ":id",
        name: "udTable.edit",
        component: AppUdtablesItem,
        meta: {
          auth: {
            roles: "udTable.update",
            redirect: { name: "udTable.index" }
          }
        }
      }
    ]
  }
];

export default routes;
